// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import IconArrowPrev from '../../Icons/IconArrowPrev';
import IconArrowFirst from '../../Icons/IconArrowFirst';
import IconArrowLast from '../../Icons/IconArrowLast';
import ExpandedRow from './ExpandedTable';
import { useAuthStore } from '../../store/AuthContext';
import NoData from '../../components/NoData';
import { PaginationUtils } from '../../utils/PaginationUtils';

type Props = {
  data: DataCompra[];
  total: number;
  withPagination: boolean;
  isTicketDownloadable: boolean;
};

interface DataCompra {
  fecha: string;
  concepto: string;
  importe: number;
  ahorroTicket: number;
  idTicket: number;
  ingresoEroskiClub: number;
  ingresoEroskiClubOro: number;
  otrosDescuentos: number;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CustomPaginationTable: FC<Props> = ({
  data,
  total,
  withPagination,
  isTicketDownloadable,
}) => {
  const dataUser = useAuthStore();
  const isApp = dataUser.user.isApp === 'true';
  const { moneda } = dataUser.user;
  const { t } = useTranslation();
  // Variables necesarias para el funcionamiento del paginado
  const [load, setLoad] = useState(0);
  const [hasFirstPoints, setHasFirstPoints] = useState<boolean>(false);
  const [hasLastPoints, setHasLastPoints] = useState<boolean>(false);
  const [cantPag, setCantPag] = useState(0);
  const [rowsToShowIfMovilOrApp, setRowsToShowIfMovilOrApp] = useState<number>(
    10,
  );

  PaginationUtils.showOrHidePagination(isApp);

  // Paginado automatico para version Movil(Browser y App)
  PaginationUtils.smartphonePagination(
    isApp,
    rowsToShowIfMovilOrApp,
    setRowsToShowIfMovilOrApp,
    data,
  );
  const handlePageChange = (page: number) => {
    setTimeout(() => {
      const table = document.querySelector('.react-bs-table') as HTMLElement;
      const rowsExpanded = document.querySelectorAll('tr.tr-static');
      rowsExpanded.forEach((row) => {
        const r = row as HTMLElement;
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        r.nextElementSibling.setAttribute('hidden', 'hidden');
        table.style.setProperty('height', '520px', 'important');
      });
    }, 0.5);

    PaginationUtils.configPagination(
      page,
      cantPag,
      hasFirstPoints,
      setHasFirstPoints,
      hasLastPoints,
      setHasLastPoints,
    );
  };

  useEffect(() => {
    if (withPagination) {
      if (window.outerWidth < 992 || isApp) {
        setRowsToShowIfMovilOrApp(10);
      } else {
        setCantPag(Math.ceil(data.length / 10));
        if (load === 1 && data.length > 0) {
          PaginationUtils.reloadPagination(Math.ceil(data.length / 10));
          setLoad(0);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (withPagination && window.outerWidth >= 992 && !isApp) {
      if (load === 0 && data.length > 0 && cantPag > 0) {
        PaginationUtils.addPagination(cantPag, load, setLoad, setHasLastPoints);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const handleSizePerPageChange = (sizePerPage: number) => {
    console.log('handleSizePerPageChange', sizePerPage);
  };

  const isExpandableRow = () => {
    return true;
  };

  const expandRowComponent = (row: DataCompra) => {
    return (
      <ExpandedRow data={row} isTicketDownloadable={isTicketDownloadable} />
    );
  };

  const stripedClass = (row: DataCompra) => {
    return `tr-static row-${row.idTicket}`;
  };

  const priceFormatter = (cell: any) => {
    let precioConComa = cell as string;
    if (precioConComa && precioConComa.toString().indexOf('.') !== -1) {
      precioConComa = precioConComa.toString().replace(/\./g, ',');
    }
    return `${precioConComa}${moneda === 'euro' ? t('euro') : t('cc')}`;
  };

  const iconDropDownFormatter = (cell: any) => {
    return `${cell}${moneda === 'euro' ? t('euro') : t('cc')}<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 15"
      class="row-expand-icon"
    >
      <polygon
        fillRule="evenodd"
        points="2.832 5 12 14.216 21.168 5 24 7.832 12 19.832 0 7.832"
        transform="translate(0 -5)"
      />
    </svg>`;
  };

  const addClassRow = (row: DataCompra) => {
    const table = document.querySelector('.react-bs-table') as HTMLElement;
    const rowExpanded = document.querySelector(
      `.detalle-fila__container-${row.idTicket}`,
    ) as HTMLElement;
    const tableHeight = table.offsetHeight;

    const tr = document.getElementsByClassName(`row-${row.idTicket}`);
    const rowExpandedContainer = (tr.item(0) as HTMLElement).nextElementSibling;
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const icon = tr.item(0).querySelector('svg');
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (tr.item(0).classList.contains('activa')) {
      table.style.setProperty(
        'height',
        `${tableHeight - rowExpanded.offsetHeight - 26}px`,
        'important',
      );
      if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        !rowExpandedContainer.hasAttribute('hidden')
      ) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        rowExpandedContainer.setAttribute('class', 'hidden');
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      tr.item(0).classList.remove('activa');
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      icon.classList.remove('icon-rotate');
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      tr.item(0).classList.add('activa');

      setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        if (tr.item(0).classList.contains('activa')) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          rowExpandedContainer.removeAttribute('hidden');
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          rowExpandedContainer.setAttribute('class', '');

          table.style.setProperty(
            'height',
            `${tableHeight + rowExpanded.offsetHeight + 26}px`,
            'important',
          );
        }
      }, 0.5);

      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      icon.classList.add('icon-rotate');
    }
  };

  const options = {
    page: 1,
    sizePerPage: window.outerWidth < 992 || isApp ? rowsToShowIfMovilOrApp : 10,
    pageStartIndex: 1,
    paginationSize: 5, // the pagination bar size.
    prePage: (
      <div className="icon icon-medium">
        <IconArrowPrev />
      </div>
    ),
    nextPage: (
      <div className="icon icon-medium">
        <IconArrowPrev classCss="u-rotate-180" />
      </div>
    ),
    firstPage: (
      <div className="icon icon-medium go-back">
        <IconArrowFirst />
      </div>
    ),
    lastPage: (
      <div className="icon icon-medium">
        <IconArrowLast />
      </div>
    ),
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    onPageChange: handlePageChange,
    onSizePerPageList: handleSizePerPageChange,
    onRowClick: addClassRow,
  };

  return (
    <>
      {/* Elemento oculto FirstPage para clonar y poder añadirlo al paginado */}
      <li id="first-page" className="page-item hidden">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="" className="page-link">
          <div className="icon icon-medium go-back">
            <IconArrowFirst />
          </div>
        </a>
      </li>

      {/* Elemento oculto LastPage para clonar y poder añadirlo al paginado */}
      <li id="last-page" className="page-item hidden">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="" className="page-link">
          <div className="icon icon-medium">
            <IconArrowLast />
          </div>
        </a>
      </li>
      {(() => {
        if (data !== null && data.length > 0) {
          return (
            <BootstrapTable
              data={data}
              options={options}
              pagination={withPagination}
              fetchInfo={{ dataTotalSize: total }}
              expandableRow={isExpandableRow}
              expandComponent={expandRowComponent}
              trClassName={stripedClass}
            >
              <TableHeaderColumn
                dataField="idTicket"
                isKey
                columnClassName="td-fecha-compras"
                hidden
                dataSort
              />
              <TableHeaderColumn
                dataField="fecha"
                className="th-fecha-compras"
                columnClassName="td-fecha-compras"
                width="130"
                dataSort
              >
                {t('compras.date')}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="concepto" width="250">
                {t('compras.concept')}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="importe"
                className="th-importe-compras"
                columnClassName="td-importe-compras"
                width="85"
                dataFormat={priceFormatter}
              >
                {t('compras.amount')}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="ahorroTicket"
                className="th-puntos-compras"
                columnClassName="td-puntos-compras"
                width="120"
                dataFormat={iconDropDownFormatter}
              >
                {t('compras.savedTickets')}
              </TableHeaderColumn>
            </BootstrapTable>
          );
        }
        return (
          <NoData>
            <div className="mensaje">
              <p>{t('compras.noRecords')}</p>
            </div>
          </NoData>
        );
      })()}
    </>
  );
};

export default CustomPaginationTable;
